import type { ReadSearchApiArg } from 'lib-search-types';
import { useMemo } from 'react';

import { useAppSearchParams } from 'utils/url/useAppSearchParams';

import { transformConversationsParamsToSearchApiArg } from './utils/transformConversationsParamsToSearchApiArg';

type UseConversationsParamsToApiArgResult = {
  /** The Search API arg derived from URL params. */
  readonly searchApiArg: ReadSearchApiArg<'conversations', true>;
};

/**
 * A hook that takes the URL params of the conversations page and converts them
 * to the Search API arg for use with the Search API.
 */
export const useConversationsParamsToApiArg =
  (): UseConversationsParamsToApiArgResult => {
    const { params } = useAppSearchParams('/conversations');

    return useMemo(
      () => ({
        searchApiArg: transformConversationsParamsToSearchApiArg(params),
      }),
      [params],
    );
  };
